export enum SearchIndex {
    Private = 1,
    Company = 2,
    Authority = 3,
}